import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import * as fromSubscriptionLinkedSubscriptions from './subscription-linked-subscriptions.reducer'
import { SubscriptionLinkedSubscriptionsEffects } from './subscription-linked-subscriptions.effects'
import { SubscriptionLinkedSubscriptionsSerializer } from './subscription-linked-subscriptions.serializer'
import { SubscriptionLinkedSubscriptionsService } from './subscription-linked-subscriptions.service'

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        StoreModule.forFeature(fromSubscriptionLinkedSubscriptions.FEATURE_NAME, fromSubscriptionLinkedSubscriptions.subscriptionLinkedSubscriptionsReducer),
        EffectsModule.forFeature([SubscriptionLinkedSubscriptionsEffects])
    ],
    providers: [
        SubscriptionLinkedSubscriptionsService,
        {
            provide: SubscriptionLinkedSubscriptionsSerializer,
            useClass: SubscriptionLinkedSubscriptionsSerializer
        }
    ],
    declarations: [],
    exports: []
})
export class SubscriptionLinkedSubscriptionsModule {}
